export interface LojaProps {
  cod_loja: number | undefined;
  des_loja: string;
  label: string;
  selected: boolean;
  uf: string;
  value: number | undefined;
  num_cnpj: string;
  cod_cidade: number | undefined;
  empresa: {
    flg_envia_ibs_cbs: boolean;
    per_cbs_teste: number;
    per_ibs_mun_teste: number;
    per_ibs_uf_teste: number;
  };
}
export const lojaDefault: LojaProps = {
  cod_loja: undefined,
  des_loja: '',
  label: '',
  selected: false,
  uf: '',
  value: undefined,
  num_cnpj: '',
  cod_cidade: undefined,
  empresa: {
    flg_envia_ibs_cbs: false,
    per_cbs_teste: 0,
    per_ibs_mun_teste: 0,
    per_ibs_uf_teste: 0,
  },
};
